import { Vue, Component, Prop } from 'vue-property-decorator'
import ProductCart from '~/types/api/ProductCart'
import OrderStep from '~/types/enum/OrderStep'
import LinkItem from '~/types/LinkItem'
import Breadcrumb from '~/components/page/Breadcrumb'
import SectionHelper from '~/utils/sectionHelper'
import s from '~/utils/s'
import ArrowSvg from '~/assets/svg/link-arrow.svg?inline'
import { OrderItem } from '~/types/api/order/Order'

@Component
export default class OrderHeader extends Vue {
  @Prop({ type: Array, default: () => ([]) })
  readonly breadcrumb?: LinkItem[]

  get isSuccessStep () {
    return s(this.$store).orderPage.orderStep === OrderStep.Success
  }

  get isHaveProducts () {
    return s(this.$store).orderPage.basketItems.length > 0
  }

  get isResultStep () {
    return s(this.$store).orderPage.orderStep === OrderStep.ResultStep
  }

  renderItem (item: OrderItem, link: string) {
    const isDiscount = item.price < item.basePrice
    return (
      <nuxt-link to={link} class="order-header__basket-list-item">
        <div class="order-header__basket-list-item-name">
          {item.title}
        </div>
        <div class="order-header__basket-list-item-info">
          <div class="order-header__basket-list-item-count">
            {item.amount} шт.
          </div>
          {isDiscount &&
            <div class="order-header__basket-list-item-discount">
              {item.basePrice} ₽
            </div>
          }
          <div class="order-header__basket-list-item-price">
            {item.price} ₽
          </div>
        </div>
      </nuxt-link>
    )
  }

  renderBreadcrumb () {
    return (
      <div class="page-header__breadcrumb">
        <Breadcrumb {...{
          props: {
            items: this.breadcrumb
          }
        }} />
      </div>
    )
  }

  renderHeader () {
    const helper = new SectionHelper(s(this.$store).general.sections, this.$store)
    return (
      <div class="order-header__content">
        <h1 class="order-header__header">
          {this.isHaveProducts || this.isSuccessStep ? 'Оформление заказа' : 'Корзина пуста'}
        </h1>
        {this.isHaveProducts && !this.isSuccessStep && !this.isResultStep &&
          <div class="order-header__basket-list-wrapper">
            <div class="order-header__basket-button">
              Состав заказа
            </div>
            <div class="order-header__basket-container-wrapper">
              <div class="order-header__basket-container">
                <div class="order-header__basket-list" style="max-height: 433px">
                  {s(this.$store).orderPage.basketItems.map((e) => {
                    const link = helper.getProductLink(s(this.$store).categoryPage.category.id, e.seoUrl ?? e.id)
                    return this.renderItem(e, link)
                  })}
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    )
  }

  renderBackStep () {
    switch (s(this.$store).orderPage.orderStep) {
      case OrderStep.Delivery:
        return (
          <div class="order-header__bask-step" onClick={() => s(this.$store).orderPage.setOrderStep(OrderStep.UserData)}>
            <ArrowSvg />
            <div class="order-header__back-text">
              Данные покупателя
            </div>
          </div>
        )
      case OrderStep.Payment:
        return (
          <div class="order-header__bask-step" onClick={() => s(this.$store).orderPage.setOrderStep(OrderStep.Delivery)}>
            <ArrowSvg />
            <div class="order-header__back-text">
              Данные доставки
            </div>
          </div>
        )
    }
  }

  render () {
    return (
      <div class="page-header order-header">
        <div class="page-header__container">
          <div class="order-header__breadcrumb">
            {this.isHaveProducts && this.renderBackStep()}
            {this.renderBreadcrumb()}
          </div>
          {this.renderHeader()}
        </div>
      </div>
    )
  }
}
